/* eslint-disable no-console */
import { isDevelopment } from "../utils/assembly";
import { localStorageSafe, setLocalStorageItem } from "../utils/storage/storage";
import { CACHE_PREFIX } from "./baseApi";
import {
  consoleLogError,
  consoleLogGroup,
  consoleLogInfo,
  consoleLogSuccess,
  consoleLogWarning
} from "../utils/console";
import { dispatchCustomEvent } from "../utils/dom";
import {
  CUSTOM_EVENT_CONTENT_VERSION_DIFFERS,
  STORAGE_KEY_CONTENT_VERSION
} from "../utils/storage/storage.constants";
import { joinObjArrays } from "../utils/array";

export const CACHE_LANG = "langCache";
export const CACHE_SEARCH_HISTORY = "searchHistory";
export const CACHE_SUBSCRIPTION_BOOKS = "subscriptionBooks";
export const CACHE_RELEVANT_FORMS = "relevantSearchForms";
const CACHE_BOOKS = "books_cache";

const scope = "💵 Network cache";

export const makeDumpCacheName = (lang) => "dump_" + lang;

const IS_DEBUG = false;
const isDebugCache = () => isDevelopment() && IS_DEBUG;

export const storeBooks = (books) => {
  if (!books) {
    return null;
  }

  const isDebugCacheValue = isDebugCache();

  let bookList = null;
  const t1 = Date.now();

  const cacheValue = localStorageSafe.getItem(CACHE_BOOKS);

  if (cacheValue) {
    try {
      bookList = JSON.parse(cacheValue);
    } catch (error) {
      consoleLogError("Store books", "Parse cache value ERROR: ", {
        cacheValue, key: CACHE_BOOKS,
      });
    }
  }

  try {
    const booksWithoutChildren = books.map((book) => {
      const bookWithoutChildren = { ...book };
      delete bookWithoutChildren.children;
      delete bookWithoutChildren.chapters;
      return bookWithoutChildren;
    });

    bookList = bookList ? joinObjArrays([booksWithoutChildren, bookList]) : booksWithoutChildren;

    setLocalStorageItem(CACHE_BOOKS, JSON.stringify(bookList), false);
  } catch (e) {
    consoleLogError("Store books", "Save to storage ERROR: ", {
      key: CACHE_BOOKS, bookList,
    });
  }

  if (isDebugCacheValue) {
    consoleLogInfo("Store books", "Stored. Time=" + Date.now() - t1, {
      count: bookList.length,
      bookList,
      books,
    });
  }

  return bookList;
};

const cleanNetworkCache = () => {
  consoleLogInfo(scope, "Clearing cache...");
  console.groupCollapsed("Network cleared items");
  Object.keys(localStorageSafe).forEach((item) => {
    if (item.indexOf(CACHE_PREFIX) === 0) {
      localStorageSafe.removeItem(item);
      console.log(item);
    }
  });
  localStorageSafe.removeItem(CACHE_BOOKS);
  console.log(CACHE_BOOKS);
  console.groupEnd();
};


export function checkNetworkCache(
  version, withReloadIfDiffers = false, isConsoleLogsSuccessOrInfo
) {
  if (window && localStorageSafe && version) {
    const currentVersion = localStorageSafe.getItem(STORAGE_KEY_CONTENT_VERSION);
    const isVersionDiffers = !!currentVersion && (
      new Date(currentVersion).getTime() !== new Date(version).getTime()
    );

    if (isVersionDiffers) {
      consoleLogWarning("Content version", "Differs! Cache will will be cleaned!");
      consoleLogGroup("More info about content versions", { currentVersion, version });

      cleanNetworkCache();
      dispatchCustomEvent(CUSTOM_EVENT_CONTENT_VERSION_DIFFERS);

      setLocalStorageItem(STORAGE_KEY_CONTENT_VERSION, version);

      if (withReloadIfDiffers) {
        if (global.window) {
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      }
    } else {
      setLocalStorageItem(STORAGE_KEY_CONTENT_VERSION, version);

      if (isConsoleLogsSuccessOrInfo) {
        consoleLogSuccess("Content version", "OK!");
      }
    }
  }
}
